// extracted by mini-css-extract-plugin
export default {"current":"bk_gT","update":"bk_gV"};